import React from "react";

import { defaultSettings } from "./defaults/settings";
import Component from "./Component";
import Form from "./Form/ReviewsForm";

const createPlugin = (settings) => {
    const mergedSettings = { ...defaultSettings, ...settings };

    return {
        FormComponent: (props) => <Form {...props} />,

        Component: (props) => <Component {...props} {...mergedSettings} />,

        name: "insinkerator/content/reviews",
        version: "1.0.0",
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            label: mergedSettings.defaultLabel,
            heading: "What they say",
            reviews: [],
            selectedCardIndex: 0,
            border: false,
        }),
    };
};

export default createPlugin;
